/**
 * Reads the first defined of several wire keys. Bridges the lot DTO cutover
 * (canonical vs legacy field names) while the deployed API still serves the
 * legacy wire; dies when the old wire does.
 */
export function wireRead<T>(obj: unknown, ...keys: string[]): T | undefined {
    if (!obj || typeof obj !== 'object') return undefined;
    const record: Record<string, unknown> = obj as Record<string, unknown>;
    for (const key of keys) {
        const value: unknown = record[key];
        if (value !== undefined && value !== null) {
            return value as T;
        }
    }
    return undefined;
}
